export type GetQueryOptions = {
  disabled?: boolean;
  enabled?: boolean;
};

export enum PayerVertical {
  MEDICAL = 'Medical',
  DENTAL = 'Dental',
}
